const ONBOARDING_SESSION_STORAGE_PREFIX = 'wl-onboarding-session:v1:';

const getOnboardingSessionStorageKey = (sessionKey: string | null): string | null => {
  const normalizedSessionKey = sessionKey?.trim();

  return normalizedSessionKey ? `${ONBOARDING_SESSION_STORAGE_PREFIX}${normalizedSessionKey}` : null;
};

export const clearOnboardingSessionHandled = (sessionKey: string | null): void => {
  const storageKey = getOnboardingSessionStorageKey(sessionKey);

  if (!storageKey) return;

  try {
    sessionStorage.removeItem(storageKey);
  } catch {
    return;
  }
};

export const getIsOnboardingHandledInSession = (sessionKey: string | null): boolean => {
  const storageKey = getOnboardingSessionStorageKey(sessionKey);

  if (!storageKey) return false;

  try {
    return sessionStorage.getItem(storageKey) === '1';
  } catch {
    return false;
  }
};

export const markOnboardingHandledInSession = (sessionKey: string | null): void => {
  const storageKey = getOnboardingSessionStorageKey(sessionKey);

  if (!storageKey) return;

  try {
    sessionStorage.setItem(storageKey, '1');
  } catch {
    return;
  }
};